import getTranslatedText from "../filters/translateFilter";

export default [
    {
        name: getTranslatedText('January'),
        monthIndex: 0
    },
    {
        name: getTranslatedText('February'),
        monthIndex: 1
    },
    {
        name: getTranslatedText('March'),
        monthIndex: 2
    },
    {
        name: getTranslatedText('April'),
        monthIndex: 3
    },
    {
        name: getTranslatedText('May'),
        monthIndex: 4
    },
    {
        name: getTranslatedText('June'),
        monthIndex: 5
    },
    {
        name: getTranslatedText('July'),
        monthIndex: 6
    },
    {
        name: getTranslatedText('August'),
        monthIndex: 7
    },
    {
        name: getTranslatedText('September'),
        monthIndex: 8
    },
    {
        name: getTranslatedText('October'),
        monthIndex: 9
    },
    {
        name: getTranslatedText('November'),
        monthIndex: 10
    },
    {
        name: getTranslatedText('December'),
        monthIndex: 11
    },
]